import { render, staticRenderFns } from "./ExpiredLink.vue?vue&type=template&id=15b0260a&scoped=true"
import script from "./ExpiredLink.vue?vue&type=script&lang=js"
export * from "./ExpiredLink.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLink.vue?vue&type=style&index=0&id=15b0260a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0260a",
  null
  
)

export default component.exports